<!-- Разделитель дня в журнале событий: дата и разбивка событий по типам (создание, изменение, удаление) -->
<template>
  <div class="log-date-divider">
    <span class="log-date-divider-label">{{ label }}</span>
    <div v-if="stats" class="log-date-stats">
      <span class="log-stat-badge log-stat-badge--total">
        {{ formatEventCount(stats.total) }}
      </span>
      <span
        v-if="stats.create"
        class="log-stat-badge log-stat-badge--create"
      >
        {{ stats.create }} создано
      </span>
      <span
        v-if="stats.update"
        class="log-stat-badge log-stat-badge--update"
      >
        {{ stats.update }} изменено
      </span>
      <span
        v-if="stats.destroy"
        class="log-stat-badge log-stat-badge--destroy"
      >
        {{ stats.destroy }} удалено
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityLogDateDivider",

  props: {
    label: {
      type: String,
      required: true,
    },
    stats: {
      type: Object,
      default: null,
    },
  },

  methods: {
    formatEventCount(count) {
      const pr = new Intl.PluralRules("ru");
      const forms = { one: "событие", few: "события", many: "событий" };
      return `${count} ${forms[pr.select(count)]}`;
    },
  },
};
</script>

<style scoped>
.log-date-divider {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 24px var(--base-in-indent) 8px;
}

.log-date-divider-label {
  font-size: 20px;
  font-weight: 700;
  color: #374151;
  white-space: nowrap;
}

.log-date-stats {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.log-stat-badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.log-stat-badge--total {
  color: #1d4ed8;
  background: #dbeafe;
}

.log-stat-badge--create {
  color: #166534;
  background: #dcfce7;
}

.log-stat-badge--update {
  color: #854d0e;
  background: #fef3c7;
}

.log-stat-badge--destroy {
  color: #991b1b;
  background: #fee2e2;
}

@media (max-width: 600px) {
  .log-date-divider {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
